import React, { Fragment, lazy } from 'react';
import { Route } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
const OnboardingFlow = lazy(() => import('../pages/OnboardingFlow').then(m => ({
  default: m.OnboardingFlow
})));
const DashboardPage = lazy(() => import('../pages/DashboardPage').then(m => ({
  default: m.DashboardPage
})));
const UploadPage = lazy(() => import('../pages/UploadPage').then(m => ({
  default: m.UploadPage
})));
const AnalysisPage = lazy(() => import('../pages/AnalysisPage').then(m => ({
  default: m.AnalysisPage
})));
const ProfilePage = lazy(() => import('../pages/ProfilePage').then(m => ({
  default: m.ProfilePage
})));
const AllScansPage = lazy(() => import('../pages/AllScansPage').then(m => ({
  default: m.AllScansPage
})));
const SettingsPage = lazy(() => import('../pages/SettingsPage').then(m => ({
  default: m.SettingsPage
})));
const MonthlyReportPage = lazy(() => import('../pages/MonthlyReportPage').then(m => ({
  default: m.MonthlyReportPage
})));
const PremiumToolsPage = lazy(() => import('../pages/PremiumToolsPage').then(m => ({
  default: m.PremiumToolsPage
})));
const MessageRewriterPage = lazy(() => import('../pages/MessageRewriterPage').then(m => ({
  default: m.MessageRewriterPage
})));
const PaymentPage = lazy(() => import('../pages/PaymentPage').then(m => ({
  default: m.PaymentPage
})));
const ReferralsPage = lazy(() => import('../pages/ReferralsPage').then(m => ({
  default: m.ReferralsPage
})));
export const protectedRoutes = <Fragment data-id="element-10669" data-mp="3eocf2r0sukbs">
    <Route path="/onboarding" element={<ProtectedRoute data-id="element-10671" data-mp="3jgvsnnzhlfgl">
          <OnboardingFlow data-id="element-10672" data-mp="3jhdud04x4lvw" />
        </ProtectedRoute>} data-id="element-10670" data-mp="3eoktwoghfzpm" />
    <Route path="/dashboard" element={<ProtectedRoute data-id="element-10674" data-mp="2m0yfsm9mpcoi">
          <DashboardPage data-id="element-10675" data-mp="2r0baft6qro1n" />
        </ProtectedRoute>} data-id="element-10673" data-mp="2m1rnpqkbq888" />
    <Route path="/dashboard/referrals" element={<ProtectedRoute data-id="element-10677" data-mp="3uafekq9ooyeq">
          <ReferralsPage data-id="element-10678" data-mp="3u9xibtn0uk6t" />
        </ProtectedRoute>} data-id="element-10676" data-mp="2qyqhg802sd5w" />
    <Route path="/upload" element={<ProtectedRoute data-id="element-10680" data-mp="3pbvrunn9nilb">
          <UploadPage data-id="element-10681" data-mp="6y4yehgizwqy" />
        </ProtectedRoute>} data-id="element-10679" data-mp="3pcnm9v54naa0" />
    <Route path="/analysis" element={<ProtectedRoute data-id="element-10683" data-mp="2wt6u6e3d1g4">
          <AnalysisPage data-id="element-10684" data-mp="2xm32dffc8k0" />
        </ProtectedRoute>} data-id="element-10682" data-mp="6xmt6vbvy86w" />
    <Route path="/tools" element={<ProtectedRoute data-id="element-10686" data-mp="3bd5v594czkxh">
          <PremiumToolsPage data-id="element-10687" data-mp="3begxd4i5okmh" />
        </ProtectedRoute>} data-id="element-10685" data-mp="3bccwkvfk01qf" />
    <Route path="/tools/rewriter" element={<ProtectedRoute data-id="element-10689" data-mp="3kd16pf1tthy1">
          <MessageRewriterPage data-id="element-10690" data-mp="3kdb07cm2y78h" />
        </ProtectedRoute>} data-id="element-10688" data-mp="36eb9lzf0bi9o" />
    <Route path="/premium-tools" element={<ProtectedRoute data-id="element-10692" data-mp="3fcenc9jr3aqx">
          <PremiumToolsPage data-id="element-10693" data-mp="3fgaux3x218if" />
        </ProtectedRoute>} data-id="element-10691" data-mp="3fdy4s3h57rua" />
    <Route path="/profile" element={<ProtectedRoute data-id="element-10695" data-mp="unqu2uxovtu7">
          <ProfilePage data-id="element-10696" data-mp="uoigbf5ecf7t" />
        </ProtectedRoute>} data-id="element-10694" data-mp="zlil7mqifbxc" />
    <Route path="/all-scans" element={<ProtectedRoute data-id="element-10698" data-mp="133ya6wks8dy9">
          <AllScansPage data-id="element-10699" data-mp="133g6xfzpczgu" />
        </ProtectedRoute>} data-id="element-10697" data-mp="uq39b0c2bq3k" />
    <Route path="/monthly-report" element={<ProtectedRoute data-id="element-10701" data-mp="t6jtcvuy5n5f">
          <MonthlyReportPage data-id="element-10702" data-mp="t73f6nnpwvoq" />
        </ProtectedRoute>} data-id="element-10700" data-mp="177e3pk1k1y6q" />
    <Route path="/settings" element={<ProtectedRoute data-id="element-10704" data-mp="y6ps0vzmw9x0">
          <SettingsPage data-id="element-10705" data-mp="y5wqc9fj8alq" />
        </ProtectedRoute>} data-id="element-10703" data-mp="t8wlu2ybzfwq" />
    <Route path="/payment" element={<ProtectedRoute data-id="element-10707" data-mp="1lxlcf81rg2u8">
          <PaymentPage data-id="element-10708" data-mp="1qu29irqxtrjg" />
        </ProtectedRoute>} data-id="element-10706" data-mp="1luz95klwk9ht" />
  </Fragment>;